<template>
    <div
        :class="[
            'c-algolia-search__form c-algolia-search__form--mini',
            { 'c-algolia-search__form--visible': headerSearchPanelOpen },
        ]"
    >
        <div class="c-algolia-search__field c-algolia-search__field--keywords">
            <div class="c-algolia-search__input-wrapper">
                <input
                    v-model="searchText"
                    type="text"
                    placeholder="Keywords"
                    v-on:keyup.enter="triggerSearchPages"
                />
                <button class="c-algolia-search__button" @click="triggerSearchPages">Search</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
    name: 'SiteSearchField',
    props: {
        searchPage: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapFields([
            "searchApp.search.searchText",
            "searchApp.headerSearchPanelOpen",
        ]),
    },
    methods: {        
        triggerSearchPages() {
            const params = new URLSearchParams({
                selectedCategories: 'all',
                sort: '',
                searchText: this.searchText,
                start: 0
            });

            window.location.href = `${this.searchPage}?${params.toString()}`;
        },
    },
};
</script>